import { selectors as streamSelectors } from '../../Stream';
import { watchedGroupsStreamId, recommendedGroupsStreamId } from './constants';
export function isNetworkBarLoading(state) {
    return (!streamSelectors.isInitialized(state, watchedGroupsStreamId) ||
        !streamSelectors.isInitialized(state, recommendedGroupsStreamId) ||
        streamSelectors.isFetching(state, watchedGroupsStreamId) ||
        streamSelectors.isFetching(state, recommendedGroupsStreamId));
}
export function getCanUserHaveWatchedGroups(state) {
    return (streamSelectors.getItems(state, watchedGroupsStreamId).length > 0 ||
        streamSelectors.isFetching(state, watchedGroupsStreamId) ||
        streamSelectors.hasMore(state, watchedGroupsStreamId));
}
//# sourceMappingURL=selectors.js.map